module.exports = __webpack_public_path__ + "static/media/diagramacao.f1c43329.svg";